import {FormControl, Grid2 as Grid, InputLabel, ListSubheader, MenuItem, Select} from "@mui/material";
import React from "react";

export interface FormSelectItem {
  name: string;
  value?: string;
  children?: FormSelectItem[];
}

interface FormSelectProps {
  name: string;
  label: string;
  items: FormSelectItem[];
  values: Record<string, any>;
  multiple?: boolean;
  onChange: (name: string, value: any) => void;
  size?: number | "grow" | "auto";
}

const renderOptions: (items: FormSelectItem[]) => React.JSX.Element[] = (items) =>
  items.map(item => item.children
    ? <><ListSubheader>{item.name}</ListSubheader>{renderOptions(item.children)}</>
    : <MenuItem key={item.name + "/" + item.value} value={item.value}>{item.name}</MenuItem>);

const renderValue = (selected: any) => {
  if (typeof selected !== "object")
    return selected;
  if (selected.length === 0)
    return <em>Default (all)</em>;
  return selected.join(", ");
};

export default function FormSelect({
  name,
  label,
  items,
  values,
  multiple = false,
  onChange,
  size = 12
}: FormSelectProps) {
  const labelId = "select-label-" + name;

  return <Grid size={size}>
    <FormControl fullWidth>
      <InputLabel shrink={true} id={labelId}>{label}</InputLabel>
      <Select
        label={label}
        labelId={labelId}
        notched={true}
        name={name}
        data-testid={name}
        multiple={multiple}
        value={values[name]}
        displayEmpty
        renderValue={renderValue}
        onChange={e => onChange(name, e.target.value)}>
        {renderOptions(items)}
      </Select>
    </FormControl>
  </Grid>;
}
